<template>
  <div class="news-list">
    <div class="row">
      <div class="col-6 col-md-3 news-list__col" v-for="(item, index) in newsList" :key="`news-item-${index + 1}`">
        <news-item :item="item" />
      </div>
    </div>

    <div class="news-list__footer">
      <button v-if="page <= 5" class="btn btn-primary" type="button" :disabled="isLoading" @click="onClick">
        Показать еще
      </button>
      <a v-else-if="!isLoading" class="btn btn-primary" href="https://kamgov.ru/news?keywords=542" target="_blank">Все новости по теме</a>
    </div>
  </div>
</template>

<script>
import NewsItem from './NewsItem'

export default {
  components: {
    NewsItem
  },
  data () {
    return {
      newsList: [],
      isLoading: true,
      page: 1
    }
  },
  watch: {
    page () {
      this.fetchData()
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.isLoading = true

      this.$http.api.get(`/news?keywords=542&json=1&pageSize=4&page=${this.page}`)
        .then((response) => {
          this.newsList = this.newsList.concat(response.data)
          this.$nextTick(() => {
            this.isLoading = false
          })
        }, (error) => {
          console.error(error)
        }).catch(() => null)
    },
    onClick () {
      this.page++
    }
  }
}
</script>

<style lang="scss" scoped>
.news-list {
  &__col {
    margin-bottom: 40px;
  }

  &__footer {
    text-align: center;
  }
}
</style>
